import type { CSSProperties, FC, ReactNode } from 'react'

import Image from 'next/image'

import { cn } from '@/lib/utils'

interface PlateProps {
    src: string
    alt: string
    className?: string
    sizes?: string
    parallax?: string
    caption?: string
    hoverable?: boolean
    priority?: boolean
    style?: CSSProperties
}

/**
 * A photographic plate: clipped on reveal, drifting against the scroll,
 * with the transform held on an inner wrapper so the measured box never
 * moves and the parallax cannot feed back into itself.
 */
export const Plate: FC<PlateProps> = ({
    src,
    alt,
    className,
    sizes = '(max-width: 767px) 100vw, 70vw',
    parallax = '60',
    caption,
    hoverable,
    priority,
    style
}): ReactNode => {
    return (
        <figure
            className={cn('rv-media', className)}
            data-reveal='mask'
            data-parallax={parallax}
            data-hoverable={hoverable ? 'true' : undefined}
            style={style}
        >
            <span className='rv-media-inner'>
                <Image
                    src={src}
                    alt={alt}
                    fill
                    sizes={sizes}
                    quality={82}
                    priority={priority}
                    loading={priority ? undefined : 'eager'}
                    style={{ objectFit: 'cover' }}
                />
            </span>

            {caption && (
                <figcaption className='rv-media-cap'>
                    {caption}
                </figcaption>
            )}
        </figure>
    )
}
